import { useMutation } from '@apollo/client';
import { CREATE_EXTERNAL_PAYMENT } from 'graphql/mutations/createExternalPayment';
import { Linking } from 'react-native';
import { usePaymentStore } from 'stores/paymentStore';
import {
  ExternalPaymentInput,
  Mutation,
  MutationCreateExternalPaymentArgs,
} from 'types/generatedSchemaTypes';

const useCreateExternalPayment = ({
  onFreeComplete,
  onRetryComplete,
}: {
  onFreeComplete: () => Promise<void>;
  onRetryComplete?: () => void;
}) => {
  const [createExternalPayment, { loading }] = useMutation<
    Mutation,
    MutationCreateExternalPaymentArgs
  >(CREATE_EXTERNAL_PAYMENT, {
    onCompleted: async (data, options) => {
      const { actionType } = options?.variables?.input as ExternalPaymentInput;
      const callbackUrl = encodeURIComponent(
        actionType === 'START_PARKING'
          ? 'com.aimoone://park?externalPayment=true'
          : 'com.aimoone://'
      );
      const paymentUrl = data?.createExternalPayment?.paymentUrl;
      if (paymentUrl) {
        const linkingUrl = `${paymentUrl}&callbackurl=${callbackUrl}`;
        if (actionType === 'RETRY_PAYMENT') {
          onRetryComplete?.();
        }
        await Linking.openURL(linkingUrl);
      } else {
        await onFreeComplete();
      }
    },
    onError: () => {
      usePaymentStore.getState().setExternalPaymentFlowLoading(false);
    },
  });

  return {
    createExternalPayment,
    loading,
  };
};

export default useCreateExternalPayment;
